export const sectionHeadingConstansts = {
    sectionCharacterLimit : 25
}